<template>
    <div class="reader-nav">
        <div v-tooltip="{ content: 'Close: Esc', trigger: 'hover'}" class="close-reader-mode" @click="$emit('close-reader-mode')">
            <svg width="24" height="24" viewBox="0 0 24 24">
                <path fill="#FFFFFF" fill-rule="evenodd" d="M11.12 16.038c.055.092.13.176.222.248.19.147.425.217.658.214.233.003.467-.067.658-.214a.907.907 0 0 0 .223-.248l4.88-5.078c.355-.37.309-.928-.103-1.246-.413-.318-1.035-.277-1.39.093L12 14.248 7.732 9.807c-.355-.37-.977-.411-1.39-.093-.412.318-.458.876-.103 1.246l4.88 5.078z" />
            </svg>
        </div>
        <div class="container">
            <div v-if="readerThemes.length" class="row">
                <div
                    v-for="(theme, index) in readerThemes"
                    :key="theme.id"
                    class="col d-none d-xl-block text-truncate"
                    @click="setReaderTheme(index)"
                >
                    <theme-pill :theme="theme" />
                </div>
                <div class="theme-dropdown-container ml-auto mr-auto col-12 d-flex d-xl-none">
                    <hb-dropdown
                        ref="themesDropdown"
                        class="themes-dropdown"
                        :is-icon="false"
                        :align="'bottom'"
                    >
                        <template slot="btn">
                            <theme-pill :theme="readerThemes[selectedReaderTheme]">
                                <template #icon>
                                    <svg width="24" height="24" viewBox="0 0 24 24">
                                        <path
                                            fill="#FFFFFF"
                                            fill-rule="nonzero"
                                            d="M4.609 17.597a1.017 1.017 0 0 1 0-2.033h.65c.556 0 1.016.46 1.016 1.02a1.02 1.02 0 0 1-1.016 1.013h-.65zm4.43 0a1.017 1.017 0 0 1 0-2.033h10.345c.56 0 1.02.459 1.02 1.02 0 .56-.46 1.013-1.02 1.013H9.039zm-4.43-9.17a1.017 1.017 0 0 1-1.013-1.012c0-.56.457-1.012 1.013-1.012h.65c.555 0 1.016.453 1.016 1.012A1.02 1.02 0 0 1 5.26 8.427h-.65zm4.43 0a1.017 1.017 0 0 1-1.012-1.012c0-.56.456-1.012 1.012-1.012h10.345c.56 0 1.02.451 1.02 1.012 0 .558-.46 1.012-1.02 1.012H9.039zm-4.43 4.585a1.02 1.02 0 0 1-1.013-1.017c0-.558.458-1.015 1.013-1.015h.65c.555 0 1.016.457 1.016 1.015 0 .556-.462 1.017-1.016 1.017h-.65zm4.43 0a1.02 1.02 0 0 1-1.012-1.017c0-.559.456-1.015 1.012-1.015h10.345c.56 0 1.02.455 1.02 1.015 0 .558-.46 1.017-1.02 1.017H9.039z"
                                        />
                                    </svg>
                                </template>
                            </theme-pill>
                        </template>
                        <template slot="body">
                            <ul>
                                <li class="close-dropdown">
                                    <a href="#" @click.prevent="$refs.themesDropdown.isHidden = true">
                                        <img src="@assets/img/x-gray.svg" alt="X" width="16px">
                                    </a>
                                </li>
                                <li v-for="(theme, index) in readerThemes" :key="index">
                                    <a href="" @click.prevent="setReaderTheme(index)">
                                        <theme-pill :theme="theme" />
                                    </a>
                                </li>
                            </ul>
                        </template>
                    </hb-dropdown>
                </div>
            </div>
        </div>
        <div class="nav-controls">
            <transition name="fade" mode="out-in">
                <button v-show="showButton" class="btn btn-outline" @click="$emit('show-bottom-player')">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path
                            fill="#FFFFFF"
                            fill-rule="nonzero"
                            d="M17.828 11.185l-7.507-5.938c-.344-.258-.787-.329-1.181-.14-.394.163-.64.539-.64.961v11.876c0 .422.246.798.64.962.148.07.32.094.468.094.246 0 .516-.094.713-.235l7.507-5.937c.247-.212.394-.493.394-.822 0-.305-.147-.61-.394-.821z"
                        />
                    </svg>
                </button>
            </transition>
            <share-dropdown :networks="$_networks" :network-events="$_networkEvents" />
            <hb-dropdown
                class="font-resize"
                :is-icon="false"
                :align="'left'"
                close-on-click
            >
                <template slot="btn">
                    <button class="btn btn-outline">
                        Aa
                        <svg viewBox="0 0 256 512" class="bp-dropdown__icon bp-dropdown__icon--down">
                            <path
                                fill="#FFFFFF"
                                d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"
                            />
                        </svg>
                    </button>
                </template>
                <template slot="body">
                    <div>
                        <ul>
                            <li>
                                <a href="#" @click.prevent="$emit('theme-font-styles', normal)">
                                    Aa
                                </a>
                            </li>
                            <li>
                                <a href="#" @click.prevent="$emit('theme-font-styles', large)">
                                    Aa
                                </a>
                            </li>
                        </ul>
                    </div>
                </template>
            </hb-dropdown>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _get from "lodash/get";
import freemiumAccessMixins from "@/mixins/freemiumAccessMixins";
import biSocialShareMixins from "@/mixins/biSocialShareMixins";


export default {
    name: "ReaderNav",
    components: {
        themePill: () => import(/* webpackChunkName: "theme-pill"*/ "@c/reader-mode/theme/theme-pill"),
        shareDropdown: () => import(/* webpackChunkName: "share-dropdown"*/
            "@c/books-insights/share-dropdown"
        )
    },
    mixins: [freemiumAccessMixins, biSocialShareMixins],
    props: {
        showButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            normal: {
                color: "$medium-gray",
                fontSize: "18px",
                lineHeight: "24px"
            },
            large: {
                color: "$medium-gray",
                fontSize: "28px",
                lineHeight: "40px"
            }
        }
    },
    computed: {
        ...mapState({
            selectedReaderTheme: state => state.NonfictionReader.selectedReaderTheme,
            readerThemes: state => state.NonfictionReader.readerThemes,
            selectedAudioSource: state => state.NonfictionPlayer.selectedAudioSource,
            audioSources: state => state.NonfictionPlayer.audioSources,
            isPlaying: state => state.NonfictionPlayer.isPlaying,
            bookInsight: state => state.NonfictionReader.bookInsight
        }),
        ...mapGetters({
            isLoggedIn: "User/isLoggedIn"
        }),
        bookInsightUrl() {
            return location.origin + this.$route.path;
        }
    },
    methods: {
        setReaderTheme(index) {
            if (index >= this.freemiumThemesAvailable && this.$_freemiumBiLocked()) {
                this.$_scrollToSignUpWall({ behavior: "smooth", block: "nearest" });
                return;
            }

            let hasProgress = true;

            if (this.audioSources.lenght) {
                hasProgress = _get(this.audioSources, `${this.selectedAudioSource}.progress`, 2) > 1;
            }

            const nextPlayerAudioIndex = this.getAudioSourceIndexById(this.readerThemes[index].id);

            this.$store.dispatch("NonfictionReader/setSelectedReaderTheme", index);
            const themeToFocus = document.getElementById(`theme-block-${index + 1}`);
            themeToFocus.scrollIntoView({ behavior: "smooth" });
            if (this.readerThemes[index].hasAudio && !this.isPlaying && !hasProgress && nextPlayerAudioIndex >= 0) {
                this.$store.dispatch("NonfictionPlayer/setSelectedAudioSource", nextPlayerAudioIndex);
            }
        },
        getAudioSourceIndexById(id) {
            return this.audioSources.findIndex(item => item.id == id);
        }
    }
}
</script>

<style lang="scss">
    .reader-nav {
        padding: 10px 0;
        height: 60px;
        z-index: 4;
        position: fixed;
        width: 100%;
        background-color: #020202;
        box-shadow: 0 0 0 0 #edf2f1;
        transition: box-shadow .5s;
        border-bottom: 1px solid #636363;

        .close-reader-mode {
            position: absolute;
            left: 40px;
            top: 10px;
            height: 38px;
            display: flex;
            align-items: center;
            z-index: 10;
            cursor: pointer;

            @media (max-width: $md) {
                left: 20px;
            }
        }

        .container {
            position: relative;
            height: 100%;

            .row {
                height: 100%;

                .col {
                    padding-left: 10px;
                    padding-right: 10px;
                }
            }
        }

        .theme-dropdown-container {
            @media (max-width: $md) {
                margin-top: 48px;
                padding-left: 0;
                padding-right: 0;
            }

            .themes-dropdown {
                margin: 0 auto;

                @media (max-width: $md) {
                    width: 100%;
                }

                .bp-dropdown__btn {
                    @media (max-width: $md) {
                        width: 100%;
                    }

                    .theme-pill {
                        width: 300px;

                        a {
                            pointer-events: none;
                        }

                        @media (max-width: $md) {
                            width: 100%;
                            border-radius: 0;
                        }
                    }
                }

                .bp-dropdown__body {
                    left: 50% !important;
                    transform: translateX(-50%);

                    @media (max-width: $md) {
                        border-radius: 0;
                    }
                }
            }
        }

        .nav-controls {
            position: absolute;
            right: 40px;
            top: 10px;
            height: 38px;
            display: flex;
            z-index: 10;

            @media (max-width: $md) {
                right: 20px;
            }

            >div {
                margin-left: 10px;

                &:first-child {
                    margin-left: 0;
                }
            }

            .font-resize {
                text-align: center;
                height: 100%;

                .btn.btn-outline {
                    color: white;
                }

                .bp-dropdown__body {
                    padding: 0;

                    ul {
                        display: flex;

                        li {
                            &:first-child {
                                border-right: 1px solid #eaeaea;

                                a {
                                    font-size: 15px;
                                }
                            }
                            &:last-child {
                                a {
                                    font-size: 25px;
                                }
                            }

                            a {
                                padding: 20px 17px;
                                font-weight: normal;
                                color: white;

                                &:hover {
                                    background-color: transparent;
                                }
                            }
                        }
                    }
                }

            }

            .btn {
                padding: 5px 10px;
                height: 100% !important;
                display: flex;
                align-items: center;
                line-height: 10px;
            }

            @media(min-width: 1201px) and (max-width: 1310px) {
                >div {
                    margin-left: 3px;
                }

                .btn {
                    padding: 5px 3px;
                }
            }
        }
    }
</style>
